"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var TextLabel = require('../textLabel');

var displayNames = require('../displayNames');

var ContextualDivider = function ContextualDivider(_ref) {
  var automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      getClassName = _ref.getClassName,
      shouldTranslate = _ref.shouldTranslate,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("div", {
    "data-aid": automationId,
    "data-hook": dataHook,
    className: getClassName('control-contextual-divider')
  }, /*#__PURE__*/React.createElement("hr", {
    className: "horizontal-line"
  }), /*#__PURE__*/React.createElement(TextLabel, {
    shouldTranslate: shouldTranslate,
    value: value,
    type: "T08"
  }), /*#__PURE__*/React.createElement("hr", {
    className: "horizontal-line"
  }));
};

ContextualDivider.displayName = displayNames.CONTEXTUAL_DIVIDER;
ContextualDivider.propTypes = {
  /** Value to be displayed as part of the divider */
  value: PropTypes.string.isRequired
};
module.exports = compose(ContextualDivider);